import React from 'react';
import { useTextDir } from '../hooks/useTextDir';
export const TextDir = ({ children }) => {
    const { formattedMessage, dir } = useTextDir(children);
    return React.createElement("div", { dir: dir }, formattedMessage);
};
